/* unplugin-vue-components disabled */import { render } from "./404.vue?vue&type=template&id=246c5cab"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
script.render = render

export default script